import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import * as SwiperActions from './swiper.actions';
import { SwiperInteraction } from './swiper.models';

@Injectable()
export class SwiperFacade {
  constructor(private readonly store: Store) {}

  interaction(interaction: SwiperInteraction) {
    this.store.dispatch(SwiperActions.interaction(interaction));
  }
}
